<div class="container-fluid">

  <!-- HEADER -->
  <div class="row align-items-center mb-3">
    <div class="col-md-6">
      <h2 class="fw-bold mb-0">Trial Balance</h2>
    </div>

    <div class="col-md-6 text-md-end mt-2 mt-md-0">
      <button
        pButton
        icon="pi pi-refresh"
        label="REFRESH"
        class="btn btn-primary btn-sm me-2"
        (click)="getDetails()">
      </button>

      <button
        pButton
        icon="pi pi-file-excel"
        label="EXPORT TO EXCEL"
        class="btn btn-danger btn-sm"
        (click)="exportExcel()">
      </button>
    </div>
  </div>

  <!-- FILTERS -->
  <div class="card p-3 mb-4">
    <div class="card-body">

    <div class="row g-3">

      <!-- Date Range -->
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
        <label class="form-label mb-0 fw-semibold">Date</label>
        <p-calendar
          [(ngModel)]="endDate"
          dateFormat="yy-mm-dd"
          inputStyleClass="form-control w-100"
          appendTo="body"
          style="width: 100%">
        </p-calendar>
        </div>
      </div>

      <!-- Location -->
      <div class="col-md-4 col-sm-12">
        <div class="form-group">
        <label class="form-label fw-semibold">Location</label>
        <p-multiSelect
          [options]="locations"
          optionLabel="displayName"
          display="chip"
          [(ngModel)]="selectedLocations"
          appendTo="body"
          style="width: 100%"
          class="w-100">
        </p-multiSelect>
        </div>
      </div>
    </div>

    </div>
  </div>

  <!-- TOTALS -->

      <div class="row text-center mt-4 fw-bold" *ngIf="trialBalance.length > 0">
      <div class="col-md-6">
        Total Debit: <span class="text-danger ms-2">{{ totDebit | number:'1.2-2' }}</span>
      </div>
      <div class="col-md-6">
        Total Credit: <span class="text-danger ms-2">{{ totCredit | number:'1.2-2' }}</span>
      </div>
    </div>

  <!-- LOADING -->
  <div *ngIf="loading" class="text-center p-4">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>

  <!-- TABLE -->
  <div *ngIf="!loading && trialBalance.length">

    <div class="table-responsive">
      <table class="table table-bordered table-hover">

        <thead>
          <tr>
            <th>Account Code</th>
            <th>Description</th>
            <th class="text-end">Debit</th>
            <th class="text-end">Credit</th>
          </tr>
        </thead>

        <tbody *ngFor="let entry of (groupedTrialBalance | keyvalue)">

          <!-- GROUP NAME -->
          <tr class="table-secondary">
            <td [attr.colspan]="4">
              <strong>{{ entry.key }}</strong>
            </td>
          </tr>

          <!-- ITEMS -->
          <tr *ngFor="let row of entry.value">
            <td>
              <a class="btn btn-link p-0" (click)="goToGeneralLedger(row.accountId)">
                {{ row.accountCode }}
              </a>
            </td>

            <td>{{ row.accountName }}</td>

            <td class="text-end">{{ row.debit | number:'1.2-2' }}</td>
            <td class="text-end">{{ row.credit | number:'1.2-2' }}</td>
          </tr>

        </tbody>

      </table>
    </div>

  </div>

</div>
